
<script>
import { useForm } from '@inertiajs/inertia-svelte';
import Svelecte from 'svelecte';

export let url;

export let sourceOptions = [];

export let languageOptions = [];

export let sectorOptions = [];

const maxSize = 5*1024*1024;

let form = useForm({
  name: '',
  email: '',
  phone: '',
  resume: null,
  org: '', // Current company / organization
  // comments: '',
  silent: false, // Disables confirmation email sent to candidates upon application. Accepts values of true, false, "true" or "false".
  source: '', // Adds a source tag to candidate (e.g. 'LinkedIn')
  location: '',
  degree: '',
  languages: [],
  sectors: [],
  salary: '',
  newsletter: null,
  accept: null
});


function submit() {
    $form.clearErrors();
    $form.post(url, {
        preserveScroll: true,
        // onSuccess: () => $form.reset('password'),
    });
}

const handleFile = e => {
    const file = e.target.files[0] || null;
    if (!file || file.size > maxSize) {
        alert('El archivo supera el tamaño máximo permitido.');
        e.preventDefault();
        $form.resume = null;
        e.target.value = null;
        return false;
    }
    $form.resume = file;
    return true;
}

</script>

<div class="pb-8 lg:pb-16">
  <div class="container xl:max-w-5xl">

    <div class="mb-8">
      <div class="text-3xl font-semibold">
        Rellena el formulario
      </div>
    </div>
    <div>


      <div>
          <form on:submit|preventDefault={submit}>
          <div class="lg:grid grid-cols-2 gap-4">
              <div class="form-group mb-6">
              <label for="name" class="font-semibold">Nombre completo<sup>*</sup></label>
              <input type="text" id="name" name="name" required bind:value={$form.name} class="form-control
                  block
                  w-full
                  px-3
                  py-3
                  text-base
                  font-normal
                  text-gray-700
                  bg-white bg-clip-padding
                  border border-solid border-gray-300
                  rounded-lg
                  transition
                  ease-in-out
                  mt-3
                  focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"
                  >
              </div>
              <div class="form-group mb-6">
              <label for="email" class="font-semibold">Email<sup>*</sup></label>
              <input type="email" id="email" name="email" required bind:value={$form.email} class="form-control block
                  w-full
                  px-3
                  py-3
                  text-base
                  font-normal
                  text-gray-700
                  bg-white bg-clip-padding
                  border border-solid border-gray-300
                  rounded-lg
                  transition
                  ease-in-out
                  mt-3
                  focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"
                  >
              </div>
          </div>
          <div class="lg:grid grid-cols-2 gap-4">
              <div class="form-group mb-6">
              <label for="phone" class="font-semibold">Teléfono<sup>*</sup></label>
              <input type="text" id="phone" name="phone" required bind:value={$form.phone} class="form-control
                  block
                  w-full
                  px-3
                  py-3
                  text-base
                  font-normal
                  text-gray-700
                  bg-white bg-clip-padding
                  border border-solid border-gray-300
                  rounded-lg
                  transition
                  ease-in-out
                  mt-3
                  focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"
                  >
              </div>

              <div class="form-group mb-6">
                <label for="location" class="font-semibold">Localidad de residencia<sup>*</sup></label>
                <input type="text" id="location" name="location" bind:value={$form.location} class="form-control
                    block
                    w-full
                    px-3
                    py-3
                    text-base
                    font-normal
                    text-gray-700
                    bg-white bg-clip-padding
                    border border-solid border-gray-300
                    rounded-lg
                    transition
                    ease-in-out
                    mt-3
                    focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"
                    >
              </div>


          </div>


        <div class="lg:grid grid-cols-2 gap-4">

            <div class="form-group mb-6">
                <label for="org" class="font-semibold">Profesión<sup>*</sup></label>
                <input type="text" id="org" name="org" required bind:value={$form.org} class="form-control
                    block
                    w-full
                    px-3
                    py-3
                    text-base
                    font-normal
                    text-gray-700
                    bg-white bg-clip-padding
                    border border-solid border-gray-300
                    rounded-lg
                    transition
                    ease-in-out
                    mt-3
                    focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"
                    >
              </div>


              <div class="form-group mb-6">
                <label for="salary" class="font-semibold">Expectativa Salarial (bruto anual en Euros)<sup>*</sup></label>
                <input type="number" id="salary" name="salary" bind:value={$form.salary} class="form-control
                    block
                    w-full
                    px-3
                    py-3
                    text-base
                    font-normal
                    text-gray-700
                    bg-white bg-clip-padding
                    border border-solid border-gray-300
                    rounded-lg
                    transition
                    ease-in-out
                    mt-3
                    focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"
                    >
              </div>

        </div>


        <div class="lg:grid grid-cols-2 gap-4">
            <div class="form-group mb-6">
                <label for="degree" class="font-semibold">Formación<sup>*</sup></label>
                <input type="text" id="degree" name="degree" bind:value={$form.degree} class="form-control
                    block
                    w-full
                    px-3
                    py-3
                    text-base
                    font-normal
                    text-gray-700
                    bg-white bg-clip-padding
                    border border-solid border-gray-300
                    rounded-lg
                    transition
                    ease-in-out
                    mt-3
                    focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"
                    >
            </div>
            <div class="form-group mb-6">
                <label for="languages" class="font-semibold">Idiomas<sup>*</sup></label>
                <!--
                <input type="text" id="languages" name="languages" bind:value={$form.languages} class="form-control
                    block
                    w-full
                    px-3
                    py-3
                    text-base
                    font-normal
                    text-gray-700
                    bg-white bg-clip-padding
                    border border-solid border-gray-300
                    rounded-lg
                    transition
                    ease-in-out
                    mt-3
                    focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"
                    >
                -->
                <Svelecte options={languageOptions} multiple={true} bind:value={$form.languages}
                    placeholder="Seleccionar"
                    class="svelecte-control form-control
                    block
                    w-full
                    px-3
                    py-3
                    text-base
                    font-normal
                    text-gray-700
                    bg-white bg-clip-padding
                    border border-solid border-gray-300
                    rounded-lg
                    transition
                    ease-in-out
                    mt-3
                    focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"
                ></Svelecte>
            </div>
        </div>

        <div class="">
        <div class="form-group mb-6">
          <label for="sectors" class="font-semibold">Sector (se puede seleccionar más de uno)<sup>*</sup></label>
          <Svelecte options={sectorOptions} multiple={true} bind:value={$form.sectors}
              placeholder="Seleccionar"
              class="svelecte-control form-control
              block
              w-full
              px-3
              py-3
              text-base
              font-normal
              text-gray-700
              bg-white bg-clip-padding
              border border-solid border-gray-300
              rounded-lg
              transition
              ease-in-out
              mt-3
              focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"
          ></Svelecte>
        </div>
        </div>

          <div class="lg:grid grid-cols-2 gap-4">
              <div class="form-group mb-6">
              <label for="source" class="font-semibold">¿Dónde has visto esta oferta?</label>
              <select id="source" name="source" bind:value={$form.source} class="form-control
                  block
                  w-full
                  px-3
                  py-3
                  text-base
                  font-normal
                  text-gray-700
                  bg-white bg-clip-padding
                  border border-solid border-gray-300
                  rounded-lg
                  transition
                  ease-in-out
                  mt-3
                  focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"
                  >
                  <option value=""></option>
                  {#each sourceOptions as o (o.id)}
                  <option value="{o.id}">{o.name}</option>
                  {/each}
              </select>
              </div>
              <div class="form-group mb-6 relative">
              <label for="resume" class="font-semibold">Adjuntar CV (PDF Max. 5 Mb)<sup>*</sup></label>
              <input type="file" id="resume" name="resume" on:input={handleFile}
                accept=".pdf"
                class="form-control
                  block
                  w-full
                  px-3
                  py-3
                  text-base
                  font-normal
                  text-gray-700
                  bg-white bg-clip-padding
                  border border-solid border-gray-300
                  rounded-lg
                  transition
                  ease-in-out
                  mt-3
                  focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"
                  >
              </div>
          </div>

          <!--
          <div class="form-group mb-6">
              <label for="comments" class="font-semibold">¿Quieres añadir algo más?</label>
              <textarea id="comments" name="comments" bind:value={$form.comments} class="form-control
              block
              w-full
              px-3
              py-3
              text-base
              font-normal
              text-gray-700
              bg-white bg-clip-padding
              border border-solid border-gray-300
              rounded-lg
              transition
              ease-in-out
              mt-3
              focus:text-gray-700 focus:bg-white focus:border-blue focus:outline-none"></textarea>
          </div>
          -->

          <div class="form-group form-check mb-6 checkbox-inline">
              <input type="checkbox" id="newsletter" name="newsletter" value="1" bind:checked="{$form.newsletter}"
              class="form-check-input h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue checked:border-blue focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain mr-2 cursor-pointer"
              >
              <label class="form-check-label inline-block text-gray-800" for="newsletter">Deseo recibir comunicaciones comerciales de MUR&PARTNERS. Puedo revocar este consentimiento en cualquier momento con efecto futuro a través de <a class="text-blue underline" href="mailto:info@mur-partners.com">info@mur-partners.com</a>.</label>
          </div>

          <div class="form-group form-check mb-6 checkbox-inline">
              <input type="checkbox" id="accept" name="accept" value="1" bind:checked="{$form.accept}"
              class="form-check-input h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue checked:border-blue focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain mr-2 cursor-pointer"
              >
              <label class="form-check-label inline-block text-gray-800" for="accept">He leído y acepto la <a target="_blank" class="text-blue underline" href="https://www.mur-partners.com/privacidad/">política de privacidad</a>.</label>
          </div>

          {#if $form.hasErrors}
          <div class="bg-red-100 rounded-lg py-5 px-6 mb-4 text-base text-red-700 mb-3" role="alert">

              {#if $form.errors.api}
                  {$form.errors.api}
              {:else}
                  Por favor, corrige los siguientes errores:
                  <ul class="list-disc pl-4">
                      {#each Object.keys($form.errors) as k (k)}
                      <li>{$form.errors[k]}</li>
                      {/each}
                  </ul>
              {/if}
          </div>
          {/if}



          <button type="submit" class="
              px-8
              py-3
              bg-blue
              text-white
              font-semibold
              rounded-full
              hover:bg-blue-700 hover:shadow-lg
              focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0
              active:bg-blue-800 active:shadow-lg
              transition
              duration-150
              ease-in-out"
              disabled={$form.processing}>
                  Enviar solicitud
                  {#if $form.processing}
                  <i class="fa fa-spinner fa-spin"></i>
                  {/if}
              </button>
          </form>
      </div>

    </div>
  </div>
</div>
